<template>
  <b-card>
    <b-row>
      <!-- people group 1 -->
      <b-col md="6">
 
        <!-- draggable -->
        <draggable
          :list="list1"
          tag="ul"
          group="people"
          class="list-group list-group-flush cursor-move"
        >
          <b-list-group-item
            v-for="(listItem, index) in list1"
            :key="index"
            tag="li"
          >
            <div class="d-flex">
              <b-form-checkbox v-model="selected" value="1"  >
              </b-form-checkbox>
              <div class="ml-25">
                <b-card-text class="mb-0 font-weight-bold">
                  {{ listItem.name }}
                </b-card-text>
               </div>
            </div>
          </b-list-group-item>
        </draggable>
      </b-col>

      <!-- people group 2 -->
      <b-col md="6" class="mt-sm-2 mt-md-0">
 
        <!-- draggable -->
        <draggable
          :list="list2"
          tag="ul"
          group="people"
          class="list-group list-group-flush cursor-move"
        >
          <b-list-group-item
            v-for="(listItem, index) in list2"
            :key="index"
            tag="li"
          >
            <div class="d-flex">
              <b-form-checkbox v-model="selected" value="1"  >
              </b-form-checkbox>
              <div class="ml-25">
                <b-card-text class="mb-0 font-weight-bold">
                  {{ listItem.name }}
                </b-card-text>
               </div>
            </div>
          </b-list-group-item>
        </draggable>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { BListGroupItem, BAvatar, BRow, BCol } from "bootstrap-vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

export default {
  components: {
    BAvatar,
    BListGroupItem,
    BRow,
    BCol,
    Prism,
    draggable,
  },
  data() {
    return {
        selected:1,
      list1: [
        {
          name: "   ملفي الشخصي ",
         },
        {
          name: "المستخدمين المتواجدين اونلاين",
         },
        {
          name: "معدل انجاز البرنامج التعليمي",
         },
        {
          name: "مهامي",
         },
      ],
      list2: [
        {
          name: "تنبيهات",
         },
        {
          name: "استفتاءات",
         },
        {
          name: "إحصائيات",
         },
        {
          name: "الفعاليات الحالية",
         },
      ],
    };
  },
};
</script>